var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.47 0.9375C13.4398 0.9375 4.94087 7.3691 1.80163 16.2508H45.1384C41.9991 7.3691 33.5002 0.9375 23.47 0.9375Z",
    fill: "#3E4347"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.47 46.8775C33.5002 46.8775 41.9991 40.5225 45.1384 31.5642H1.80163C4.94087 40.5225 13.4398 46.8775 23.47 46.8775Z",
    fill: "#FFE62E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.80163 16.2508C0.9594 18.6244 0.5 21.2277 0.5 23.9075C0.5 26.5873 0.9594 29.1906 1.80163 31.5642H45.1384C45.9806 29.1906 46.44 26.5873 46.44 23.9075C46.44 21.2277 45.9806 18.6244 45.1384 16.2508H1.80163Z",
    fill: "#ED4C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDe);
export default __webpack_public_path__ + "static/media/de.d63c9842ff32de2708aff2e0f1c84560.svg";
export { ForwardRef as ReactComponent };